import React, { Component } from 'react';
import _ from 'lodash';

import Permission from '../../components/Permission';
import Loading from '../../components/Loading';
import NoticeStore from '../../stores/NoticeStore';

import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { MergeAttributes } from '../../components/FlatData';
import SimpleModal from '../../components/SimpleModal';

import NewNoticePage from '../../components/settings/NewNoticePage';
import EditNoticePage from '../../components/settings/EditNoticePage';

export default class NoticePage extends Component {
  constructor(props){
    super(props)

    this.state = {
      create_notice: {},
      edit_notice: {},
      isDataFetched: false,
      notices: []
    }

    this.loadData = this.loadData.bind(this);
    this.actionsFormatter = this.actionsFormatter.bind(this);
    this.onClose = this.onClose.bind(this);
    this.handleCloseAndReloadData = this.handleCloseAndReloadData.bind(this);
  }

  componentDidMount(){
    if (!Permission.isAdmin()) {
      window.location.href = '/documents/mydoc';
    }else{
      this.loadData();
    }
  }

  loadData(){
    NoticeStore.request({}).then((resp)=>{
      const notices = _.get(resp.data, 'data', []);
      this.setState({
        notices: notices
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    });
  }

  _setTableOption(){ 
    if(this.state.isDataFetched){
      return "ไม่มีข้อมูล";
    }else{
      return <Loading />
    }
  }

  handleDelete(id){
    if (!window.confirm('ยืนยันการลบรายการประชาสัมพันธ์')) { return }
    
    NoticeStore.request({
      id: id,
      method: 'delete'
    }).then(()=>{
      this.loadData();
    })
  }

  actionsFormatter(cell, row) {
    return (
      <div>
        <button className='btn btn-sm btn-primary mr-2' onClick={this.onEdit.bind(this, row)}>แก้ไข</button>
        <button className='btn btn-sm btn-danger' onClick={this.handleDelete.bind(this, cell)}>ลบ</button>
      </div>
    )
  }

  onEdit(notice){
    console.log('notice ==>', notice)
    this.setState({edit_notice: notice});
  }

  onCreate(){
    this.setState({ create_notice: {title: '', url: ''} });
  }

  onClose(){
    this.setState({ create_notice: {}, edit_notice: {} });
  }

  handleCloseAndReloadData(){
    console.log('onClose')
    this.setState({ create_notice: {}, edit_notice: {} }, this.loadData());
  }

  render(){
    const options = {
      sizePerPageList: [],
      sizePerPage: 5,
      noDataText: this._setTableOption()
    };
    var data = [];
    if (!_.isEmpty(this.state.notices)){
      data = MergeAttributes(this.state.notices);
    }

    return (
      <div className='notice-setting-page'>
        {Permission.isAdmin() && (
          <div>
            <div className='row form-group'>
              <div className='col-md-12'>
                <h3 className='font-weight-bold'>จัดการรายการประชาสัมพันธ์</h3>
              </div>
            </div>

            <div className='row form-group'>
              <div className='col-12 text-right'>
                <button className='btn btn-success' onClick={this.onCreate.bind(this)}>เพิ่มรายการประชาสัมพันธ์</button>
              </div>
            </div>

            <div className='rui-notice-table'>
              <BootstrapTable 
                data={data}
                search={ true }
                multiColumnSearch={ true }
                options={ options }
                striped
                hover
                pagination
                version='4'
                tableContainerClass={'table-sm'}
                trClassName='td-white-space-normal'>
                <TableHeaderColumn isKey dataField='id' hidden></TableHeaderColumn>
                <TableHeaderColumn dataField='title' columnTitle dataSort={ true }>เรื่อง</TableHeaderColumn>
                <TableHeaderColumn dataField='url' columnTitle dataSort={ true }>URL</TableHeaderColumn>
                <TableHeaderColumn dataField='id' dataFormat={ this.actionsFormatter } columnClassName='text-center'></TableHeaderColumn>
              </BootstrapTable>
            </div>
          </div>
        )}

        {this.state.isDataFetched && !_.isEmpty(this.state.create_notice) && 
          <NewNoticePage 
            notice={this.state.create_notice} 
            handleCloseAndReloadData={this.handleCloseAndReloadData}
            onClose={this.onClose} />}

        {this.state.isDataFetched && !_.isEmpty(this.state.edit_notice) && 
          <EditNoticePage 
            notice={this.state.edit_notice} 
            handleCloseAndReloadData={this.handleCloseAndReloadData}
            onClose={this.onClose} />}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/settings/NoticePage.js